<template>
  <b-modal id="bv-modal-msgs" size="lg" title="Conversa" scrollable centered>
    <itemMessage
        v-for="(msgItem, index) in fulllog.msgs" 
        :key="'item-mensagen-'+index"
        :avatar="fulllog.meuAvatar" 
        :is-proprio="msgItem.type" 
        :exibirData="msgItem.exibirData"
        :data="msgItem.data" 
        :hora="msgItem.hora"
        :mensagem="msgItem.mensagem"
    ></itemMessage>

    <template #modal-footer>
      <div class="w-100">
        <b-button
            variant="danger"
            class="float-right"
            @click="downloadPdf()"
        >
          Baixar PDF
        </b-button>
      </div>
    </template>

    <VueHtml2pdf
        class="d-none"
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :filename="mensagens"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
        @beforeDownload="gerarPdf($event)"
    >
      <section slot="pdf-content" style="background-color: #f0f0f0; padding: 1px 0;">
        <itemMessage
        class="avoid-page-break"
            v-for="(msgItem, index) in fulllog.msgs" 
            :key="'item-mensagen-'+index"
            :avatar="fulllog.meuAvatar" 
            :is-proprio="msgItem.type" 
            :exibirData="msgItem.exibirData"
            :data="msgItem.data" 
            :hora="msgItem.hora" 
            :mensagem="mensagemPdf(msgItem.mensagem)"
        ></itemMessage>
      </section>
    </VueHtml2pdf>
  </b-modal>
</template>
<script>
import {mapGetters} from 'vuex';
import itemMessage from '../mensagem/ItemMensagen';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components:{
    itemMessage,
    VueHtml2pdf
  },

  data:() => ({
    fulllog: [],
    mensagens: 'mensagens_' + window.moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
  }),

  computed:{
    ...mapGetters(['getlogchat'])
  },

  methods:{
    openModal() {
      this.$bvModal.show('bv-modal-msgs');
      this.fulllog = this.getlogchat;
    },

    // Vídeo/áudio não aparecem no PDF (e quebram o html2canvas), então viram um texto indicativo
    mensagemPdf(mensagem) {
      if (typeof mensagem !== 'string') return mensagem;

      return mensagem
        .replace(/<video[\s\S]*?<\/video>/gi, '<span>🎥 Vídeo</span>')
        .replace(/<audio[\s\S]*?<\/audio>/gi, '<span>🎵 Áudio</span>');
    },

    // Gera o PDF manualmente para pintar de cinza o espaço que sobra no fim da última página
    async gerarPdf({ html2pdf, options, pdfContent }) {
      let canvas, pageSize;

      await html2pdf().set(options).from(pdfContent).toPdf()
        .get('canvas', c => { canvas = c; })
        .get('pageSize', p => { pageSize = p; })
        .get('pdf', pdf => {
          const pxPagina = Math.floor(canvas.width * pageSize.inner.ratio);
          const pxResto = canvas.height % pxPagina;
          if (!pxResto) return;

          const alturaUsada = pxResto * pageSize.inner.width / canvas.width;
          pdf.setPage(pdf.internal.getNumberOfPages());
          pdf.setFillColor(240, 240, 240);
          pdf.rect(0, alturaUsada, pageSize.width, pageSize.height - alturaUsada, 'F');
        })
        .save();
    },

    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    }
  },
}
</script>

<style scoped>
    .modal-log{
        position: relative;
        margin: 10% auto;
        max-height: 50em;
        padding: 30px;
        max-width: 60em;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
        background-color: #FAFAFA;
        overflow-y: auto;
    }

    .avoid-page-break {
      page-break-inside: avoid;
    }
</style>